import { Box, Tab, Tabs } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import FeeTable from '../FeeTable';
import DateRangeFilter from '../DateRangeFilter';
import { Constant } from '../../utils/constant';
import './style.scss';

interface setFundFee2025 {
  fundName: string;
  value: number;
}

interface setFundFee2024 {
  fundName: string;
  value: number;
}
// /fund/management-fees
export default function FeeTabPanel() {
  const params = useParams<{ id: string }>();
  const fundId = params?.id;
  const [feeTabValue, setFeeTabValue] = useState(0);
  const [fund2025, setFundFee2025] = useState<setFundFee2025[]>([]);
  const [fund2024, setFundFee2024] = useState<setFundFee2024[]>([]);
  // const [fundFeeByDate, setFundFeeByDate] = useState([]);


  const handleFeeTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setFeeTabValue(newValue);
  };

  const loadFundFeesData = useCallback(async () => {
    try {
      const jsonPath = `${process.env.PUBLIC_URL || ''}/data/fund-fees.json`;
      const response = await fetch(jsonPath);
      if (!response.ok) {
        throw new Error('Failed to load fund-fees.json');
      }
      const data = await response.json();
      if (fundId) {
        const fund2024 = data.year2024?.find((fund: any) => fund.fundId === fundId);
        const fund2025 = data.year2025?.find((fund: any) => fund.fundId === fundId);

        if (fund2025) {
          setFundFee2025([
            {
              fundName: "01/01/2025 - 30/06/2025",
              value: fund2025.firstHalf
            },
            {
              fundName: "01/07/2025 - 31/12/2025",
              value: fund2025.secondHalf
            }
          ]);
        } else {
          setFundFee2025([]);
        }
        if (fund2024) {
          setFundFee2024([{
            fundName: "01/01/2024 - 31/12/2024",
            value: fund2024.value
          }]);
        } else {
          setFundFee2024([]);
        }

      } else {
        console.warn('No codeID provided in URL params');
        setFundFee2025([]);
        setFundFee2024([]);
      }
    } catch (error) {
      setFundFee2025([]);
      setFundFee2024([]);
    }
  }, [fundId]);

  useEffect(() => {
    loadFundFeesData();
    // getFundFeesByDate();
    const intervalGetFund = setInterval(() => {
      loadFundFeesData();
      // getFundFeesByDate();
    }, Constant.interval);
    return () => {
      clearInterval(intervalGetFund);
    };
  }, [loadFundFeesData]);

  return (
    <>
      <Box sx={{ overflowX: 'auto', borderBottom: 1, borderColor: "divider", maxWidth: '600px', margin: '0 auto', mt: '24px' }}>
        <Tabs
          value={feeTabValue}
          onChange={handleFeeTabChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            // '& .MuiTabs-flexContainer': {
            //   justifyContent: 'center'
            // }
            minHeight: 36
          }}
        >
          <Tab disableRipple label="Từ năm 2026" />
          <Tab disableRipple label="Năm 2025" />
          <Tab disableRipple label="Năm 2024" />
        </Tabs>
      </Box>

      {feeTabValue === 0 && (
        <DateRangeFilter fundId={fundId ?? ''} />
      )}
      {feeTabValue === 1 && (
        <FeeTable
          headers={[
            "Từ ngày - Đến ngày",
            "Phí quản lý quỹ (%/năm)"
          ]}
          fees={fund2025}
          showFundNameColumn={true}
          showPercentage={true}
        />
      )}
      {feeTabValue === 2 && (
        <FeeTable
          headers={[
            "Từ ngày - Đến ngày",
            "Phí quản lý quỹ (%/năm)"
          ]}
          fees={fund2024}
          showFundNameColumn={true}
          showPercentage={true}
        />

      )}
    </>
  );
}